import { MainProductComponent } from './main-product.component';

export const MainProduct = MainProductComponent;
